module.exports = __webpack_public_path__ + "img/virtual.dacf4a5e.png";